"use strict";
/**
 * Type guards for discriminating between different banner data types
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.isAnalyticsData = exports.isCitrusBannerData = exports.isKevelBannerData = exports.isContentBlocksData = exports.isBrandAZSlotsData = void 0;
const BRAND_AZ_SLOT_COUNT = 6;
const CONTENT_BLOCK_COUNTS = [2, 4];
/**
 * Type guard to check if data represents Brand A-Z slots
 * Brand A-Z slots always have exactly 6 items with mobile and tablet images
 */
const isBrandAZSlotsData = (data) => {
    return (Array.isArray(data) &&
        data.length === BRAND_AZ_SLOT_COUNT &&
        data.every((item) => typeof item === "object" &&
            item !== null &&
            "mobileImage" in item &&
            "tabletImage" in item));
};
exports.isBrandAZSlotsData = isBrandAZSlotsData;
/**
 * Type guard to check if data represents Content Blocks
 * Content Blocks can have either 2 or 4 items
 */
const isContentBlocksData = (data) => {
    return (Array.isArray(data) &&
        CONTENT_BLOCK_COUNTS.includes(data.length) &&
        data.every((item) => typeof item === "object" &&
            item !== null &&
            "logoPosition" in item &&
            "slotNumber" in item &&
            "designType" in item));
};
exports.isContentBlocksData = isContentBlocksData;
/**
 * Type guard to check if data represents a Kevel banner
 * Kevel banners have both clickUrl and impressionUrl
 */
const isKevelBannerData = (data) => {
    return (typeof data === "object" &&
        data !== null &&
        "associatedAdvertId" in data &&
        "clickUrl" in data &&
        "impressionUrl" in data);
};
exports.isKevelBannerData = isKevelBannerData;
/**
 * Type guard to check if data represents a Citrus banner
 * Citrus banners have associatedAdvertId but not the Kevel-specific URLs
 */
const isCitrusBannerData = (data) => {
    return (typeof data === "object" &&
        data !== null &&
        "associatedAdvertId" in data &&
        !("clickUrl" in data && "impressionUrl" in data));
};
exports.isCitrusBannerData = isCitrusBannerData;
/**
 * Type guard to check if data represents analytics (empty object or no banner data)
 */
const isAnalyticsData = (data) => {
    if (typeof data !== "object" || data === null) {
        return false;
    }
    return !("associatedAdvertId" in data) && !Array.isArray(data);
};
exports.isAnalyticsData = isAnalyticsData;
